module.exports = __webpack_public_path__ + "img/w_webpage.8e6133cb.svg";